module.exports = __webpack_public_path__ + "img/how-to-video-thumbnail.a363bb0.jpg";